import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgListView = (props) => (
  <SvgIcon {...props} title="ListView">
    <svg
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.833 2.167V5.5h-12.5V2.167h12.5Zm0 8.333v3.333h-12.5V10.5h12.5Zm.834-10H1.5a.836.836 0 0 0-.833.833v5c0 .459.375.834.833.834h14.167a.836.836 0 0 0 .833-.834v-5A.836.836 0 0 0 15.667.5Zm0 8.333H1.5a.836.836 0 0 0-.833.834v5c0 .458.375.833.833.833h14.167a.836.836 0 0 0 .833-.833v-5a.836.836 0 0 0-.833-.834Z"
        fill={props.fill}
      />
    </svg>
  </SvgIcon>
);

export default SvgListView;
